export default {
  title: 'Ne manquez rien !',
  description: 'Activez les notifications pour suivre votre commande.',
  buttons: {
    enable: 'Activer',
  },
};
